import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import { FooterWrapper } from './footer.styles';
import { Content } from './content/content.component';
import { TermsBar } from './termsBar/termsBar.component';
import { PageSection } from '../../components/contentManager/pageSection';
import { identifiers } from '../../utils/rendering';

export class Footer extends PureComponent {
  static propTypes = {
    contentType: PropTypes.string.isRequired,
    entryId: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
    footer: PropTypes.object,
    location: PropTypes.object,
  };

  get color() {
    return this.props.footer.getIn(['color', 'fields', 'color']);
  }

  get footerImage() {
    return this.props.footer.getIn(['footerImage', 'fields', 'file', 'url']);
  }

  get footerImageAlt() {
    return this.props.footer.getIn(['footerImage', 'fields', 'title']);
  }

  get shopItem() {
    return this.props.footer.getIn(['shopItem', 'fields']);
  }

  get form() {
    return this.props.footer.get('form');
  }

  get contactUsData() {
    return {
      title: this.props.footer.get('contactTitle'),
      text1: this.props.footer.get('contact1Text'),
      icon1: this.props.footer.get('contact1Icon'),
      text2: this.props.footer.get('contact2Text'),
      icon2: this.props.footer.get('contact2Icon'),
      text3: this.props.footer.get('contact3Text'),
      icon3: this.props.footer.get('contact3Icon'),
    };
  }

  get column2() {
    return this.props.footer.get('column2');
  }

  get column3() {
    return this.props.footer.get('column3');
  }

  get shop() {
    const footer = this.props.footer;

    return {
      title: footer.get('shopTitle'),
      text: footer.get('shopText'),
      link: footer.get('shopLink'),
      image: footer.get('shopImage'),
      imageLink: footer.get('shopImageLink'),
    };
  }

  get image() {
    return this.props.footer.get('image');
  }

  get socialIconList() {
    return this.props.footer.get('socialIconList');
  }

  get bottomBarLinks() {
    return this.props.footer.getIn(['bottomBarLinks', 'fields', 'items']);
  }

  get copyright() {
    return this.props.footer.get('copyright');
  }

  get photoDisclaimer() {
    return this.props.footer.get('photoDisclaimer');
  }

  get footerBadges() {
    const footerBadges = this.props.footer.get('footerBadges');

    if (footerBadges && footerBadges.size > 2) {
      return footerBadges.slice(0, 2);
    }

    return footerBadges;
  }

  render() {
    const { contentType, entryId, location } = this.props;

    return (
      <PageSection index={999}>
        <FooterWrapper {...identifiers('Footer', contentType, entryId)} role="contentinfo">
          <Content
            form={this.form}
            contactUs={this.contactUsData}
            footerImage={this.footerImage}
            footerImageAlt={this.footerImageAlt}
            color={this.color}
            shopItem={this.shopItem}
            column2={this.column2}
            column3={this.column3}
            shop={this.shop}
            image={this.image}
            location={location}
            footerBadges={this.footerBadges}
          />
          <TermsBar
            links={this.bottomBarLinks}
            copyright={this.copyright}
            socialLinks={this.socialIconList}
            photoDisclaimer={this.photoDisclaimer}
          />
        </FooterWrapper>
      </PageSection>
    );
  }
}
